import React, { useCallback, useEffect } from 'react';

import { useFilterContext } from '../lib';

interface BreedComponentProps {
  breed: string;
  count: number;
  urlSearchParams: URLSearchParams;
}

const BreedComponent: React.FC<BreedComponentProps> = ({ breed, count, urlSearchParams }) => {
  const { selectedBreeds, setSelectedBreeds } = useFilterContext();

  const savedType = sessionStorage.getItem('breeds');
  const searchParam = urlSearchParams.get('breeds');
  const savedBreeds = savedType?.split(',');

  const updateUrl = useCallback(
    (updatedBreeds: string[]) => {
      if (updatedBreeds.length === 0) {
        urlSearchParams.delete('breeds');
      } else {
        urlSearchParams.set('breeds', updatedBreeds.join(','));
      }
    },
    [urlSearchParams]
  );

  const onSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trim();

    const updatedBreeds = event.target.checked
      ? [...selectedBreeds, value]
      : selectedBreeds.filter((breed) => breed !== value);

    sessionStorage.setItem('breeds', updatedBreeds.join(','));
    setSelectedBreeds(updatedBreeds);
    updateUrl(updatedBreeds);
  };

  useEffect(() => {
    if (!savedType) {
      setSelectedBreeds([]);
    } else if (!searchParam) {
      sessionStorage.removeItem('breeds');
    } else {
      setSelectedBreeds(savedType.split(','));
    }
  }, [searchParam, savedType, setSelectedBreeds]);

  return (
    <section onClick={(e) => e.stopPropagation()} className="flex items-center gap-2 pt-2 md:pt-4">
      <input
        className="h-4 w-4"
        onChange={onSelect}
        type="checkbox"
        id={`breed-${breed}`}
        value={breed}
        checked={[...selectedBreeds, ...(savedBreeds ?? [])].includes(breed)}
      />
      <label htmlFor={`breed-${breed}`}>
        {breed} <b>{count}</b>
      </label>
    </section>
  );
};

export default BreedComponent;
